// extracted by mini-css-extract-plugin
export default {"Logo":"SunTimesLogo_Logo__Yv8Uz","DarkLogo":"SunTimesLogo_DarkLogo__G4Q9w","Star":"SunTimesLogo_Star__pBpa1","Small":"SunTimesLogo_Small__7Qt96"};